// extracted by mini-css-extract-plugin
export var container = "_9m-0";
export var icon = "_9m-1";
export var text = "_9m-2";